import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2706b9b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-box" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("生成发票")

import { ref, reactive, onMounted} from 'vue'
import dayjs from 'dayjs'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  emits: ['advancePaymentCreatInvoice'],
  setup(__props, { expose, emit }) {

let {
    'POST/order/delivering_or_proceeding':orderListApi
} =Api

const queryInfo=ref<any>({})
const tableHeight=window.innerHeight-300
const orderListLoading=ref(false)
const orderList=ref([])
const pageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const selectedData=ref<any>([])
const invoiceTableRef=ref()
const getOrderLists=(isReset:boolean=false)=>{
    if(isReset){
        queryInfo.value={}
        pageInfo.page=1,
        pageInfo.size=30
        invoiceTableRef.value.clearSort()
        sortParams.value={}
    }
    let {page,size}=pageInfo
    let {no,poNumber,createTime,deliverTime,customerName}=queryInfo.value
    let params={
        query:{
            no,poNumber ,customerName,page,size,
            startTimeFrom:createTime?dayjs(createTime[0]).format('YYYY-MM-DD'):"",
            startTimeTo:createTime?dayjs(createTime[1]).format('YYYY-MM-DD'):"",
            deliverTimeFrom:deliverTime?dayjs(deliverTime[0]).format('YYYY-MM-DD'):"",
            deliverTimeTo:deliverTime?dayjs(deliverTime[1]).format('YYYY-MM-DD'):"", 
        },
        sort:sortParams.value
       
    }
    orderListLoading.value=true
    orderListApi(params).then((res:any)=>{
        orderList.value=res.data
        pageInfo.total=res.rowCount
    }).finally(()=>{
        orderListLoading.value=false
    })
}
const handleSelectionChange=(value:any)=>{
    selectedData.value=value
}
const sortParams=ref<any>({})
const sortMethods=({prop,order}:any)=>{
    let orderVal=order?order=='descending'?'DESC':'ASC':''
    if(orderVal){
        if(prop=='startTime'){
            sortParams.value.start_time=orderVal
        }
        if(prop=='deliverTime'){
            sortParams.value.deliver_time=orderVal
        }  
    }else{
         if(prop=='startTime'){
           delete sortParams.value.start_time
        }
        if(prop=='deliverTime'){
            delete sortParams.value.deliver_time
        }
    }
    getOrderLists()
}
const createInvoice=()=>{
    if(!selectedData.value.length){
        ElMessage.warning('请先勾选订单数据')
        return
    }
    let orderNos:any=selectedData.value.map((el:any)=>el.no)
    emit('advancePaymentCreatInvoice',{orderNos,type:'merge'})
}
onMounted(()=>{
    getOrderLists()
})
expose({
    getOrderLists
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, { accordion: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点击搜索" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_form, {
                inline: "",
                model: queryInfo.value,
                "label-width": "100px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "订单号：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        style: {"width":"220px"},
                        modelValue: queryInfo.value.no,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryInfo.value.no) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "PO号: " }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        style: {"width":"220px"},
                        modelValue: queryInfo.value.poNumber,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryInfo.value.poNumber) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "客户名称: " }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        style: {"width":"220px"},
                        modelValue: queryInfo.value.customerName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryInfo.value.customerName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "创建日期：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: queryInfo.value.createTime,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryInfo.value.createTime) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "交付日期：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: queryInfo.value.deliverTime,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryInfo.value.deliverTime) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (getOrderLists()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (getOrderLists(true)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      type: "primary",
      class: "mt-10 mb-10",
      onClick: createInvoice
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "max-height": tableHeight,
      onSortChange: sortMethods,
      ref_key: "invoiceTableRef",
      ref: invoiceTableRef,
      onSelectionChange: handleSelectionChange,
      border: "",
      data: orderList.value,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          prop: "no",
          label: "订单号",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "client",
          label: "客户名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "contact",
          label: "联系人"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "订单名称",
          width: "180",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "owner",
          label: "客户经理"
        }),
        _createVNode(_component_el_table_column, {
          prop: "creator",
          label: "创建人"
        }),
        _createVNode(_component_el_table_column, {
          prop: "poNumber",
          label: "PO号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "po",
          label: "PO"
        }),
        _createVNode(_component_el_table_column, {
          prop: "amount",
          label: "总金额",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "currency",
          label: "货币"
        }),
        _createVNode(_component_el_table_column, {
          prop: "startTime",
          label: "开始时间",
          sortable: "",
          formatter: (row)=>_unref(dayjs)(row.startTime).format('YYYY-MM-DD')
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "deliverTime",
          label: "交付时间",
          sortable: "",
          formatter: (row)=>_unref(dayjs)(row.deliverTime).format('YYYY-MM-DD')
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "invoiceCompany",
          label: "开票主体"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态"
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, orderListLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      class: "mt-15",
      "current-page": _unref(pageInfo).page,
      "onUpdate:current-page": _cache[7] || (_cache[7] = ($event: any) => ((_unref(pageInfo).page) = $event)),
      "page-size": _unref(pageInfo).size,
      "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => ((_unref(pageInfo).size) = $event)),
      onSizeChange: _cache[9] || (_cache[9] = ()=>getOrderLists()),
      onCurrentChange: _cache[10] || (_cache[10] = ()=>getOrderLists()),
      background: "",
      layout: "prev, pager, next, sizes, total",
      total: _unref(pageInfo).total,
      "page-sizes": [30, 60, 100, 120]
    }, null, 8, ["current-page", "page-size", "total"])
  ], 64))
}
}

})